<!--     
    Copyright (c) 2022 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
<div class="image">
  <img class="image" [src]="profile" alt="profile" />
</div>
<div class="cam">
  <label for="edit">
    <img
      alt="image"
      class="icon"
      src="../../../../assets/icons/profile-cam.svg"
    />
  </label>
  <input
    class="upload"
    id="edit"
    accept="image/*"
    type="file"
    name="profilePhoto"
    (change)="onFileSelected($event)"
  />
</div>
